import { Stack } from '@/components/layout';
import { Button, TextInput } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { AuthView } from '@/features/auth/components';
import { useEnterPassword } from '@/features/auth/hooks/use-enter-password';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { useState } from 'react';

export function EnterPasswordScreen() {
  const { password, onChangePassword, handleSignIn, handleForgotPassword } = useEnterPassword();
  const styles = useStyles();
  const { scale } = useScaling();
  const [secureTextEntry, setSecureTextEntry] = useState(true);
  return (
    <AuthView>
      <AuthView.Content>
        <Stack
          paddingTop={scale({
            phone: 120,
            tablet: 60,
          })}
          align="center">
          <AuthView.PlayerPathwayImage />
        </Stack>

        <Stack
          width="100%"
          paddingX={scale({
            phone: 16,
            tablet: 40,
          })}
          paddingTop={scale({
            phone: 48,
            tablet: 30,
          })}
          gap={scale({
            phone: 24,
            tablet: 16,
          })}
          align="center">
          <TextInput
            value={password}
            onChangeText={onChangePassword}
            status={'default'}
            secureTextEntry={secureTextEntry}
            onSecureTextEntryChange={setSecureTextEntry}>
            <TextInput.Content>
              <TextInput.Icon
                size={scale({
                  phone: 16,
                  tablet: 20,
                })}
                name="IcLock"
                position="left"
              />
              <TextInput.Field
                placeholder={STRINGS.auth.enterPassword.placeholderPassword}
                autoCapitalize="none"
                maxLength={50}
                autoCorrect={false}
                placeholderTextColor={colors['Labels/Tertiary']}
              />
              <TextInput.PasswordToggle
                size={scale({
                  phone: 16,
                  tablet: 20,
                })}
              />
            </TextInput.Content>
          </TextInput>

          <Stack
            gap={scale({
              phone: 16,
              tablet: 12,
            })}
            align="center">
            <Button onPress={handleSignIn} style={styles.button}>
              <Button.Text>{STRINGS.auth.enterPassword.buttonSignIn}</Button.Text>
            </Button>

            <Button
              variant="outline"
              onPress={() => {
                handleForgotPassword();
                setSecureTextEntry(true);
              }}
              style={styles.button}>
              <Button.Text>{STRINGS.auth.enterPassword.buttonForgotPassword}</Button.Text>
            </Button>
          </Stack>
        </Stack>
        <Stack flex={1} />

        <Stack align="center" gap={scale(0)}>
          <AuthView.BackPressable />
          <AuthView.Hint />
          <AuthView.Logo />
        </Stack>
      </AuthView.Content>
    </AuthView>
  );
}

const useStyles = createStyles(({ scale }) => ({
  button: {
    width: scale(212),
  },
  backText: {
    color: colors.Blue,
    textAlign: 'center',
  },
}));
